import styled, { css } from 'styled-components';
import { B as Box } from '../Box/Box-DQvfytPi.js';
import { g as getPadding } from '../LocalModules/storm-ui-utils/dist/esm/getPadding-Bvzhcf_u-BhHYy5ob.js';

/* eslint-disable import/prefer-default-export */
const FlexBox = /*#__PURE__*/styled(Box).withConfig({
  componentId: "sc-storm-ui-30063520__sc-nae1j8-0"
})(["display:flex;border-radius:unset;", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], ({
  $direction
}) => css(["flex-direction:", ";"], $direction), ({
  $alignContent
}) => css(["align-content:", ";"], $alignContent), ({
  $justifyContent
}) => css(["justify-content:", ";"], $justifyContent), ({
  $alignItems
}) => css(["align-items:", ";"], $alignItems), ({
  theme,
  $columnGap
}) => css(["column-gap:", "px;"], getPadding(theme, $columnGap)), ({
  theme,
  $rowGap
}) => css(["row-gap:", "px;"], getPadding(theme, $rowGap)), ({
  $wrap
}) => css(["flex-wrap:", ";"], $wrap), ({
  $shrink
}) => css(["flex-shrink:", ";"], $shrink), ({
  $grow
}) => css(["flex-grow:", ";"], $grow), ({
  $basis
}) => css(["flex-basis:", ";"], $basis));

export { FlexBox as F };
//# sourceMappingURL=Flex.styles-fIhv10j8.js.map
